import axios from "axios";

export const requestOutstandingFees = (slug) =>
  axios.get(`/api/route?path=fees-outstanding/${slug}/extra-charge-collection`);

export const requestCreateOrder = (slug) =>
  axios.get(
    `/api/route?path=fees-outstanding/${slug}/extra-charge-collection/create-order`
  );
